import React from 'react';

import { ICropItemProps } from '@/modules/periodicJobs/components/CropsDropdown/CropItem/ICropItem';
import { NextImage, Typography } from '@/shared/components/atoms';

const CropItem: React.FC<ICropItemProps> = ({
  onClick,
  selected,
  imageUrl,
  name,
}) => {
  return (
    <button
      onClick={onClick}
      style={{ backgroundColor: selected ? '#D0F3E9' : undefined }}
      className='flex w-full cursor-pointer items-center gap-x-2 rounded-xl px-16 py-8'
    >
      {name && imageUrl && (
        <div className='flex h-32 w-32 items-center justify-center overflow-hidden rounded-full'>
          <NextImage
            width={100}
            height={100}
            src={imageUrl}
            alt={name}
            className='max-h-full max-w-full'
            useSkeleton
          />
        </div>
      )}
      <Typography component='h6' weight='semiBold'>
        {name}
      </Typography>
    </button>
  );
};

export default CropItem;
